<script setup lang="ts">
  defineProps<{
    observation: string[];
  }>();
</script>

<template>
  <div class="h-auto flex flex-col gap-2">
    <div class="font-semibold flex">
      Observações:
    </div>
    <div
      class="rounded-2xl border flex flex-col items-start p-5 min-h-26.5 border-border-color bg-gray-02/20 break-all"
    >
      <div
        v-for="(line, index) in observation"
        :key="index"
      >
        {{ line }}
      </div>
    </div>
  </div>
</template>
